import React from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Button
} from "@sainsburys-tech/fable";
import apiProxy from "../../api/apiProxy";
import ButtonWithApiCall from "../ButtonWithApiCall";
import { AlertCircleFilled } from '@sainsburys-tech/icons'

const OverrideDiscardModal = props => {
  const handleDiscardClick = () => {
    return apiProxy.override
      .discardOverride(props.overrideId)
      .then(() => props.onDiscardSuccess());
  };
  return (
    <Modal isOpen={props.open} onClose={props.onClose}>
      <h3 style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
        <AlertCircleFilled className="fable:mr-8 fable:text-red-600" />
        Are you sure you want to discard this override?
      </h3>
      <p>This override will be removed from the stores.</p>
      <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1.5rem' }}>
        <ButtonWithApiCall
          label="Discard"
          savingMessage="Discarding Override"
          useInlineError
          onClick={handleDiscardClick}
        />
        <Button variant="secondary" onClick={props.onClose}>Cancel</Button>
      </div>
    </Modal>
  );
};

OverrideDiscardModal.propTypes = {
  overrideId: PropTypes.string,
  onDiscardSuccess: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default OverrideDiscardModal;
